import { render, staticRenderFns } from "./Notes.vue?vue&type=template&id=69bc0a95&scoped=true"
import script from "./Notes.vue?vue&type=script&lang=js"
export * from "./Notes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69bc0a95",
  null
  
)

export default component.exports